// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28906":"d15d4c0e","44305":"d15d4c0e"}[chunkId] + ".chunk.css";
};